import { Lazyload } from '@vant/lazyload';
export default Lazyload;